import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';

@Component({
  selector: 'app-refund-button-cell',
  templateUrl: './refund-button-cell.component.html',
  styleUrls: ['./refund-button-cell.component.scss'],
  standalone: false
})
export class RefundButtonCellComponent {

  @Input() isRefunded: boolean;
  @Input() paymentRequestId: string;
  @Input() canRefund: boolean;

  @Output() refund = new EventEmitter<string>();

  confirmationModal: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Refund Payment',
    modalSubDescp: 'Are you sure you want to mark this payment as refunded in GeoPermits? This action cannot be undone.',
    yesNoBtn: true,
    status: 'info'
  }

  openRefundConfirmation(event?: Event) {
    event?.stopPropagation();
    this.confirmationModal = {
      ...this.confirmationModal,
      open: true
    };
  }

  confirmRefund() {
    this.refund.emit(this.paymentRequestId);
    this.confirmationModal = {
      ...this.confirmationModal,
      open: false
    };
  }

  cancelRefund() {
    this.confirmationModal = {
      ...this.confirmationModal,
      open: false
    };
  }

}
